export const addWindowResizeEvent = (callback) => {
	let timeout;
	window.addEventListener('resize', () => {
		clearTimeout(timeout);
		timeout = setTimeout(callback, 250);
	});
};

export const addWindowScrollEvent = (callback) => {
	let timeout;
	window.addEventListener('scroll', () => {
		clearTimeout(timeout);
		timeout = setTimeout(callback, 250);
	});
};
